import { forwardRef } from 'react';
import { Button, Col, Row, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { crawlTooltip } from '@/app/Crawl/tooltip/crawlTooltips';
import Flex from '../../../../components/common/Flex';
import AgGridChangeHeight from './AgGridChangeHeight';
import HelpTooltip from '../HelpTooltip';
import { breakpointsMediaQuery, useMediaQuery } from '@/helpers/utils';
import type { AgGridButtonsProps } from './types';

const AgGridButtons = forwardRef<HTMLDivElement, AgGridButtonsProps>(
  (
    {
      settings,
      heightState,
      setHeightState,
      saveColumnsState,
      resetColumnsState,
      isSavingState,
      heightStateBackUp,
      otherButtons
    },
    ref
  ) => {
    const isMdUp = useMediaQuery(breakpointsMediaQuery.md);

    return (
      <>
        {!settings.exportBtn &&
        !settings.fullscreen &&
        !settings.changeHeight &&
        !settings.saveGrid &&
        !settings.resetGrid ? (
          ''
        ) : (
          <Row className="g-0">
            <Col xs="auto" className="mb-3">
              {otherButtons}
            </Col>
            <Col className="">
              <Flex className="mb-3 gap-2" justifyContent="end">
                {isMdUp && settings.fullscreen && (
                  <Button
                    // disabled //BUG
                    title="تمام صفحه"
                    style={{ width: '30px', height: '30px' }}
                    variant="outline-secondary"
                    onClick={() => {
                      setHeightState(prev => {
                        heightStateBackUp.current = prev;
                        return '100vh';
                      });
                      if (ref && typeof ref !== 'function') {
                        ref.current?.requestFullscreen();
                      }
                    }}
                    className="p-1 d-flex align-items-center justify-content-center"
                  >
                    <FontAwesomeIcon
                      className="fs-0"
                      icon="expand-arrows-alt"
                    />
                  </Button>
                )}
                {isMdUp && settings.changeHeight && (
                  <AgGridChangeHeight
                    heightState={
                      typeof heightState === 'number'
                        ? heightState
                        : Number(heightState)
                          ? (heightState as unknown as number)
                          : Number(heightState.replace('px', ''))
                    }
                    setHeightState={setHeightState}
                  />
                )}
                {settings.saveGrid && (
                  <Button
                    disabled={isSavingState}
                    className="p-1 fs--1 gap-2 d-flex align-items-center justify-content-center px-2"
                    variant="secondary"
                    onClick={async () => {
                      await saveColumnsState();
                    }}
                  >
                    {!isSavingState ? (
                      <FontAwesomeIcon className="fs-0" icon="save" />
                    ) : (
                      <Spinner style={{ width: 12, height: 12 }} />
                    )}
                    <span>
                      <span className="d-md-inline d-none">ذخیره جدول</span>
                      <span onClick={e => e.stopPropagation()}>
                        <HelpTooltip
                          html={
                            <div className="text-start">
                              {crawlTooltip.saveTable}
                            </div>
                          }
                        />
                      </span>
                    </span>
                  </Button>
                )}
                {settings.resetGrid && (
                  <Button
                    className="p-1 fs--1 gap-2 d-flex align-items-center justify-content-center px-2"
                    variant="outline-secondary"
                    onClick={() => resetColumnsState()}
                  >
                    <FontAwesomeIcon className="fs-0" icon="undo-alt" />
                    <span>
                      <span className="d-md-inline d-none">ریست</span>

                      <span onClick={e => e.stopPropagation()}>
                        <HelpTooltip html={crawlTooltip.resetTable} />
                      </span>
                    </span>
                  </Button>
                )}
              </Flex>
            </Col>
          </Row>
        )}
      </>
    );
  }
);

export default AgGridButtons;
